import { put } from 'redux-saga/effects'
import { push, replace } from 'connected-react-router'

/**
 * Saga helper that navigates to a route after an async operation.
 *
 * @param {string} _redirect - Target route.
 * @param {Function} [_condition] - When provided, navigation only occurs if it returns true.
 * @param {*} data - Response data passed to the _condition.
 * @param {boolean} [useReplace=false] - When true, uses replace instead of push,
 *   preventing the current route from being added to the navigation history.
 */
export function* toLocation(_redirect, _condition, data, useReplace = false) {
  if (_redirect) {
    if (!_condition || (typeof _condition === 'function' && _condition(data))) {
      yield put(useReplace ? replace(_redirect) : push(_redirect))
    }
  }
}
